import { useEffect, useState } from "react";
import axios from 'axios';
import './Video.css';

function Video(props) {
    const [url] = useState(window.location.search);
    const [data, setData] = useState({});
    const [vimeo, setVimeo] = useState('https://player.vimeo.com/video/?autoplay=0&amp;title=0&amp;byline=0&amp;portrait=0');

    useEffect(() => {
        async function fetchData() {
            const result = await axios(
                './data/' + url.replace('?data=', '') + '_video.json',
            );
            setData(result.data);
        }
        fetchData();
    }, [url, props.lang]);

    useEffect(() => {
        switch(props.lang){
            case 'jpng':
                setVimeo('https://player.vimeo.com/video/'+data.jp+'?autoplay=0&amp;title=0&amp;byline=0&amp;portrait=0');
            break;
            case 'jpkn':
                setVimeo('https://player.vimeo.com/video/'+data.jp+'?texttrack=bh&amp;autoplay=0&amp;title=0&amp;byline=0&amp;portrait=0');
            break;
            case 'jpjp':
                setVimeo('https://player.vimeo.com/video/'+data.jp+'?texttrack=ja&amp;autoplay=0&amp;title=0&amp;byline=0&amp;portrait=0');
            break;
            case 'enng':
                setVimeo('https://player.vimeo.com/video/'+data.en+'?autoplay=0&amp;title=0&amp;byline=0&amp;portrait=0');
            break;
            case 'enen':
                setVimeo('https://player.vimeo.com/video/'+data.en+'?texttrack=en&amp;autoplay=0&amp;title=0&amp;byline=0&amp;portrait=0');
            break;
            default:
            break;
        }
    },[props.lang, data]);

    return (
        <div className='videoWrap'>
            <iframe src={vimeo} className="vimeoFrame" frameBorder="0" allow="autoplay; fullscreen" allowFullScreen="" title="vimeo"></iframe>
        </div>
    );
};

export default Video;